var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditPasswordForgot\">\n        <div class=\"MemberProfileEditPasswordForgot-body MemberProfileEdit-scrollbox\">\n            <div class=\"MemberProfileEditPasswordForgot-body-title\">Forgot Password?</div>\n            <form class=\"MemberProfileEditPasswordForgot-body-form\">\n                <div class=\"MemberProfileEditPasswordForgot-body-form-text\">\n                    Please enter your email address and we will send you instructions on how to reset your password. If\n                    you have forgotten what email address is associated with your account, please <a href=\"";
t_5 += runtime.suppressValue((lineno = 9, colno = 111, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:contact"])), env.opts.autoescape);
t_5 += "\">contact</a> the ADG\n                    office.\n                </div>\n                <div class=\"MemberProfileEditPasswordForgot-body-form-inputWrapper\">\n                    <div class=\"MemberProfileEditPasswordForgot-body-form-input-label\">\n                        Email address:\n                    </div>\n                    <input class=\"MemberProfileEditPasswordForgot-body-form-input\" type=\"text\" name=\"email\">\n                </div>\n            </form>\n        </div>\n        <div class=\"MemberProfileEditPasswordForgot-buttons\">\n            <div class=\"MemberProfileEditPasswordForgot-buttons-button MemberProfileEditPasswordForgot-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditPasswordForgot-buttons-button MemberProfileEditPasswordForgot-buttons-button--save\">\n                email me\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditPasswordForgot-confirmPopup hidden\">\n            <div class=\"MemberProfileEditPasswordForgot-confirmPopup-body\">\n                <div class=\"MemberProfileEditPasswordForgot-confirmPopup-body-title\">\n                    Thanks, ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"firstName"), env.opts.autoescape);
t_5 += "!\n                </div>\n                <div class=\"MemberProfileEditPasswordForgot-confirmPopup-body-text\">\n                    Check your email inbox, and click the link in the email you received to reset your password.\n                </div>\n                <div class=\"MemberProfileEditPasswordForgot-confirmPopup-body-btnWrap\">\n                    <div class=\"MemberProfileEditPasswordForgot-confirmPopup-body-btn\">\n                        Close\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditPasswordForgot");
context.setVariable("MemberProfileEditPasswordForgot", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja
// module id = 116
// module chunks = 0